import React from "react";
import KPIBarChart from "../WelcomePage/KPIBarChart";
import KPIStackedBarChart from "../WelcomePage/KPIStackedBarChart";
import KPILineChart from "../WelcomePage/KPILineChart";
import KPIDoughnutChart from "../WelcomePage/KPIDoughnutChart";
import WelcomeReviewStatisticsChart from "../WelcomePage/WelcomeReviewStatisticsChart";
import styles from "./advisorChartBlock.module.scss";

/**
 * Renders Advisor tool-derived charts (Welcome-compatible payloads).
 */
const AdvisorChartBlock = ({ chart, theme = "light" }) => {
  if (!chart || typeof chart !== "object") return null;
  const type = chart.chart_type;
  const title = chart.title || "";
  if (type === "review_statistics") {
    return (
      <div className={styles.wrap} data-advisor-chart={type}>
        {title ? <div className={styles.title}>{title}</div> : null}
        <div className={styles.chartBody}>
          <WelcomeReviewStatisticsChart data={chart} theme={theme} />
        </div>
      </div>
    );
  }
  const hasData =
    Array.isArray(chart.labels) &&
    chart.labels.length > 0 &&
    Array.isArray(chart.datasets) &&
    chart.datasets.some(
      (ds) => Array.isArray(ds.data) && ds.data.some((v) => Number(v) !== 0)
    );
  if (!hasData) return null;

  let body = null;
  if (type === "line") {
    body = <KPILineChart data={chart} theme={theme} hideLegend={false} />;
  } else if (type === "stacked_bar") {
    body = (
      <KPIStackedBarChart
        data={chart}
        title={title}
        theme={theme}
        horizontal={Boolean(chart.horizontal)}
      />
    );
  } else if (type === "doughnut") {
    body = <KPIDoughnutChart data={chart} theme={theme} />;
  } else {
    body = (
      <KPIBarChart
        data={chart}
        theme={theme}
        horizontal={Boolean(chart.horizontal)}
      />
    );
  }

  return (
    <div className={styles.wrap} data-advisor-chart={type || "chart"}>
      {title ? <div className={styles.title}>{title}</div> : null}
      <div className={styles.chartBody}>{body}</div>
    </div>
  );
};

export default AdvisorChartBlock;
